import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Token ophalen en valideren bij opstarten
  useEffect(() => {
    const token = localStorage.getItem('dive_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/api/auth/me')
        .then(r => {
          setUser(r.data.user);
          localStorage.setItem('dive_user', JSON.stringify(r.data.user));
        })
        .catch(err => {
          if (err.response?.status === 401) {
            // Echt auth-probleem: token ongeldig
            localStorage.removeItem('dive_token');
            localStorage.removeItem('dive_user');
            delete axios.defaults.headers.common['Authorization'];
          } else {
            // Netwerk fout (offline): gebruik gecachede gebruikersinfo
            const cachedUser = localStorage.getItem('dive_user');
            if (cachedUser) setUser(JSON.parse(cachedUser));
          }
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const { data } = await axios.post('/api/auth/login', { username, password });
    localStorage.setItem('dive_token', data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('dive_token');
    localStorage.removeItem('dive_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
